export function isMediaElement(input) {
  return input instanceof HTMLImageElement || input instanceof HTMLVideoElement || input instanceof HTMLCanvasElement;
}